export var ACTION;
(function (ACTION) {
    ACTION["ON_CHANGE_SLIDER"] = "ON_CHANGE_SLIDER";
    ACTION["ON_CHANGE_COMPLETE_SLIDER"] = "ON_CHANGE_COMPLETE_SLIDER";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["GO_CONFIRM_PLEDGE"] = "GO_CONFIRM_PLEDGE";
    ACTION["EDIT_PORTFOLIO"] = "EDIT_PORTFOLIO";
    ACTION["EDIT_LIMIT"] = "EDIT_LIMIT";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["CLOSE_POPUP"] = "CLOSE_POPUP";
})(ACTION || (ACTION = {}));
